/* Choice and content stay native; only the illustration transition needs JavaScript. */
(() => {
  const init = (scope = document) => scope.querySelectorAll('[data-steak-cooking]:not([data-motion-ready])').forEach(root => {
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let motion;
    root.addEventListener('change', event => {
      if (!event.target.matches('.j-steak-cooking__radio')) return;
      motion?.cancel();
      const panel = root.querySelector(`#${CSS.escape(event.target.getAttribute('aria-controls'))}`);
      const visual = panel?.querySelector('.j-steak-cooking__visual');
      if (visual && !reduced.matches) motion = visual.animate(
        [{opacity: .5, transform: 'translateY(8px)'}, {opacity: 1, transform: 'none'}],
        {duration: 380, easing: 'ease-out'}
      );
    });
    reduced.addEventListener('change', () => { if (reduced.matches) motion?.cancel(); });
    root.dataset.motionReady = 'true';
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true}); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
